import { cn } from '@/lib/utils'

interface Props {
  icon: string
  title: string
}

const Title = ({ icon, title }: Props) => {
  return (
    <>
      <i className={cn('pi text-xl', icon)} />
      <span className="lg:ml-5">{title}</span>
    </>
  )
}

export default Title
